import React from 'react';
import ContactHero from '../components/ContactHero';
import ReachOutSection from '../components/ReachOutSection';
import LocationMapSection from '../components/LocationMapSection';
import ContactUs from '../components/ContactUs';

function ContactPage() {
  return (
    <>
      <ContactHero />
      <ReachOutSection />
      <LocationMapSection />
      <ContactUs />
    </>
  );
}

export default ContactPage;
